define('webshopCategoriesDetailBodyLandingpagesView',[
  'settings',
  'module',
  'underscore',
  'webshopLandingpagesDetailView',
  'webshopLandingpagesListView'
], function (
  Settings,
  Module,
  _,
  DetailView,
  ListView
) {
  'use strict';

  Module.exports = ListView.extend({
    className: 'webshop-landingpages-detail-body-landingpage-view ' + ListView.prototype.className,

    getFiltersParams: function(filters) {
      var params = ListView.prototype.getFiltersParams.apply(this, [filters]);
      params.categoryId = this.model.get('id');
      return params;
    },

    onAdd: function() {
      var data = {
        categoryId: this.model.get('id')
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/landingpages/add'),
        processData: false,
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: _.bind(function (data) {
          this.reload();
          this.footerView.fetch();

          if(data && data.id)
            DetailView.prototype.open(data.id);
        }, this)
      });   
    }
  });
});
